import {
  TransactionOrderType,
  TRANSACTION_CLIENT_STATES,
} from "creso-core/constants";
import { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Button,
} from "web-design-system";
import { ClientSearch } from "@core/components/client-search";
import { useNavigate } from "@tanstack/react-router";

export function BasketActionAccordion(props: { basketId: number }) {
  const { basketId } = props;
  const navigate = useNavigate();

  const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
  const [selectedClientIdForProposal, setSelectedClientIdForProposal] =
    useState<number | null>(null);

  return (
    <Accordion
      onValueChange={(v) => {
        if (v === "transaction") {
          setSelectedClientId(null);
        } else {
          setSelectedClientIdForProposal(null);
        }
      }}
      type="single"
      collapsible
    >
      <AccordionItem className="border-t" value="transaction">
        <AccordionTrigger>
          <div className="text-sm">
            <span>Create Transaction</span>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div className="flex flex-col gap-4">
            <ClientSearch
              status={TRANSACTION_CLIENT_STATES}
              onSelect={(v) => v?.id && setSelectedClientId(v.id)}
            />
            <div className="flex items-center gap-2">
              <Button
                onClick={() =>
                  navigate({
                    to: ".",
                    search: {
                      modal: "transaction",
                      collection_id: basketId,
                      collection_type: "basket",
                      type: TransactionOrderType.XSIP,
                      client_id: selectedClientId as number,
                    },
                  })
                }
                variant="outline"
                className="w-full"
              >
                SIP
              </Button>
              <Button
                onClick={() =>
                  navigate({
                    to: ".",
                    search: (prev) => ({
                      ...prev,
                      modal: "transaction",
                      collection_id: basketId,
                      collection_type: "basket",
                      type: TransactionOrderType.PURCHASE,
                      client_id: selectedClientId as number,
                    }),
                  })
                }
                className="w-full"
              >
                One time
              </Button>
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem className="border-b-0" value="proposal">
        <AccordionTrigger>
          <div className="text-sm">
            <span>Create Proposal</span>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div className="flex flex-col gap-4">
            <ClientSearch
              onSelect={(v) => v?.id && setSelectedClientIdForProposal(v.id)}
            />
            <Button
              disabled={!selectedClientIdForProposal}
              onClick={() =>
                navigate({
                  to: ".",
                  search: (prev) => ({
                    ...prev,
                    modal: "proposal",
                    collection_id: basketId,
                    collection_type: "basket",
                    client_id: selectedClientIdForProposal as number,
                    state: "init",
                  }),
                })
              }
            >
              Start
            </Button>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
